import { Box, Button, Checkbox, FormControlLabel, Typography, useMediaQuery } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { UserDetailsContext } from '../context/user-details/user-details';
import { CustomThemeContext } from '../context/theme/custom-theme-context';
import { TermsAndConditionsButton } from '../components/presentation-components/signup-login/terms-and-conditions-button';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import gaiaTheme from './theme';
import SingleSignOnService from '../shared/services/single-sign-on/single-sign-on.service';
import { usePdfExportMode } from '../hooks/use-pdf-export-mode';


// leftOffset: width in px of the left rail chrome. The rail's Drawer paints above this
// fixed banner, so the banner starts at the rail's right edge and centres its content in
// the visible area. 0 on mobile / wherever the rail is hidden.
export const TermsAndConditionsBanner = ({ leftOffset = 0 }: { leftOffset?: number }) => {
  const userDetailsContext = useContext(UserDetailsContext);
  const { partnerName } = useContext(CustomThemeContext);
  const singleSignOnService = new SingleSignOnService()
  const [showBanner, setShowBanner] = useState<boolean>(false);
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('sm'));
  const pdfExportMode = usePdfExportMode();

  useEffect(() => {
    setShowBanner(userDetailsContext.userDetails?.hasAcceptedTermsAndConditions === false 
      && window.location.pathname !== '/complete-sign-up' 
      && !window.location.pathname.startsWith('/complete-registration') 
      && !window.location.pathname.startsWith('/email-verification') 
      && !window.location.pathname.startsWith('/signup') 
      && !window.location.pathname.startsWith('/login'));
  }, [userDetailsContext, window.location.pathname]);

  const hasAcceptedTermsAndConditionsSchema = Yup.object().shape({
    termsAndConditions: Yup.boolean().oneOf([true], `You must agree to the terms and conditions to be able to use ${partnerName || 'Gaia'}`),
  })

  const formik = useFormik({
    initialValues: {
      termsAndConditions: false
    },
    validationSchema: hasAcceptedTermsAndConditionsSchema,
    onSubmit: (values) => {
      singleSignOnService.acceptTermsAndConditions(values)
        .then(response => {
          userDetailsContext.forceUpdateUserDetails()
        })
        .catch(err => {
          console.log(err)
        })
    }
  });

  if (pdfExportMode) return null;

  return (
    <>
      {showBanner && <Box sx={{
        height: isMobileMode ? '70px' : '48px',
        width: `calc(100% - ${leftOffset}px)`,
        backgroundColor: 'secondary.light',
        opacity: 0.6,
        display: 'flex',
        justifyContent: 'center',
        position: 'fixed',
        zIndex: 1000,
        alignItems: 'center',
        top: isMobileMode ? 106 : 64,
        left: `${leftOffset}px`,
      }}>
        <FormControlLabel control={
          <Checkbox
            id='termsAndConditions'
            name='termsAndConditions'
            checked={formik.values.termsAndConditions}
            onChange={formik.handleChange}
          />
        }
          label={
            <Box display='flex' flexDirection={'row'} sx={{ flexWrap: 'wrap' }} >
              <Typography variant="body1">
                To continue using {partnerName || 'Gaia'} Carbon Accounting, please review and accept our{' '}
                <TermsAndConditionsButton />
              </Typography>
            </Box>
          }
        />
        <Button disabled={!formik.values.termsAndConditions} onClick={formik.submitForm}>
          <Typography>Save</Typography>
        </Button>
      </Box>}
    </>
  )
}

